import { render } from "./TheDemandComfirmation.vue?vue&type=template&id=13cd45c6&scoped=true"
import script from "./TheDemandComfirmation.vue?vue&type=script&lang=js"
export * from "./TheDemandComfirmation.vue?vue&type=script&lang=js"

import "./TheDemandComfirmation.vue?vue&type=style&index=0&id=13cd45c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13cd45c6"

export default script